//adds an input element, For example: Used to dynamically add file upload inputs to a page as needed
$('body').on('click', 'a.addInput', function () {
  var opts = $(this).metadata().addInputOpts;
  if (opts) {
    var newClass = opts.newClass != null ? opts.newClass : '';
    var input = $(
      "<input type='" +
        opts.inputType +
        "' name='" +
        opts.name +
        "' class='" +
        newClass +
        "' />"
    );
    var uniqueID = opts.name;

    if (opts.requiresUniqueId) {
      // use recursion to find a random number and ensures that id is not used in the document
      var getUniqueID = function (name) {
        var tempID = name + Math.random();
        if ($('#' + tempID).length === 0) {
          return tempID;
        } else {
          return getUniqueID(name);
        }
      };
      uniqueID = getUniqueID(opts.name);
      input.attr('id', uniqueID);
    }

    if (opts.ariaLabel) {
      input.attr('aria-label', opts.ariaLabel);
    }

    //adds the input to the page
    input.appendTo(opts.targetSelector);

    //add wrapping element
    if (opts.encapsulatingNode) {
      input.wrap(
        '<' +
          opts.encapsulatingNode +
          " class='ht2-Layout-InputEncapsulatingNode'>"
      );
    }

    //add remove link/functionality
    if (opts.removable) {
      var removeLabel = opts.removeLabel || 'Remove';
      if (opts.encapsulatingNode) {
        $(
          "<a href='#' class='ht2-Link ht2-Layout-RemoveElementLink removeElement {removeParent: \"" +
            opts.encapsulatingNode +
            '"}\'>' +
            removeLabel +
            '</a>'
        ).insertAfter(input);
      } else {
        $(
          "<a href='#' class='ht2-Link toRemove removeElement {removeSelector: \".toRemove\"}'>" +
            removeLabel +
            '</a>'
        ).insertAfter(input);
      }
    }

    if (opts.maxFileSize) {
      input.attr(
        'data-rule-filesize',
        "{'maxsize':" + opts.maxFileSize + ",'unit':'mb'}"
      );
    }

    if (opts.noZeroByte) {
      input.attr('data-rule-nozerobyte', "{'noZeroByte': true}");
      input.change((e) => {
        $("label.ht2-ErrorText[for='" + input.id + "']").remove();

        const fileList = e.target.files;
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].size === 0) {
            $(
              "<label class='ht2-ErrorText error zeroByteError' for='" +
                input.id +
                "'>" +
                opts.zeroByteErrorMessage +
                '</label>'
            ).insertAfter('a.removeElement:last');
            input[i].value = '';
          }
        }
      });
    }

    if (opts.maxFileNameSizeMessage) {
      input.change((e) => {
        if (e.target.files.length > 0) {
          $("label.ht2-ErrorText[for='" + input.id + "']").remove();
          const fileList = e.target.files;
          for (let i = 0; i < fileList.length; i++) {
            if (fileList[i].name.length > 200) {
              $(
                "<label class='ht2-ErrorText error' for='" +
                  input.id +
                  "'>" +
                  opts.maxFileNameSizeMessage +
                  '</label>'
              ).insertAfter('a.removeElement:last');
              input[i].value = '';
            }
          }
        }
      });
    }

    //add validation
    if (opts.required) {
      //TODO: change this to add attribute
      input.addClass('required');
      if (opts.removable && opts.errorMessage) {
        $(
          "<label class='ht2-ErrorText error' for='" +
            uniqueID +
            "' style='display: none;'> " +
            opts.errorMessage +
            '</label>'
        ).insertAfter('a.removeElement:last');
      }
    }

    //Hides the file input on mobile and clicks on it, prompting the user to select a file.
    //Once the file is selected, it sets a label to the file's name.
    if (opts.mobileInput && opts.inputType === 'file') {
      input.hide();
      var nameLabel = $('<span></span>');
      nameLabel.insertAfter(input);
      input.change(() => {
        nameLabel.text(input[0].files[0].name);
      });
      input.click();
    }

    return false;
  }
});
